import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  Inject
} from '@angular/core';
import { MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';
import { NotificationConfigData } from './notification-config-data';
import { NotificationStatus } from './notification-status';

@Component({
  selector: 'labs-notification',
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class NotificationComponent {
  get icon() {
    switch (this.data.status) {
      case NotificationStatus.Warn:
        return 'warning';
      case NotificationStatus.Error:
        return 'error';
      case NotificationStatus.Success:
        return 'check_circle';
      default:
        return 'info';
    }
  }

  get title() {
    switch (this.data.status) {
      case NotificationStatus.Warn:
        return 'Warning';
      case NotificationStatus.Error:
        return 'Error';
      case NotificationStatus.Success:
        return 'Success';
      default:
        return 'Information';
    }
  }

  constructor(
    @Inject(MAT_SNACK_BAR_DATA) public data: NotificationConfigData
  ) {}

  @HostBinding('class')
  get statusClass() {
    switch (this.data.status) {
      case NotificationStatus.Warn:
        return 'warn';
      case NotificationStatus.Error:
        return 'error';
      case NotificationStatus.Success:
        return 'success';
      default:
        return 'info';
    }
  }
}
